import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    container: {
        width: '100%',
        height: '100%',
        overflow: 'auto',
    },
    row: {
        position: 'relative',
        border: 'none',
    },
});
